import * as React from "react";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";
import optimaIcon from './favicon-optima.png';
import { setListErr, setListMessage } from "../../../../../config/redux/alerts/alertsActions";
import { syncOptima, retryCuoDeliveryReport } from "../../../../../connectors/orders/connectors";
import i18next from "i18next";

interface ICompletedActions {
    openPanelToCorrect: void,
    openPanelSyncOrder: void,
    openPanel: void
}

export const generateCompleted = (quantity: IQuantity, actions: ICompletedActions, selectedOrder?: any, dispatch?: any) => {
    const t = i18next.getFixedT(null, "admin");
    const { REACT_APP_OPTIMA_ENABLED } = process.env;

    switch (quantity) {
        case Quantity.NONE:
            return [];
        case Quantity.ONE:
            if (!selectedOrder.Manually) {
                let arr: any[] = [
                    {
                        key: "see",
                        text: t("orders.commandBar.see") as string,
                        iconProps: { iconName: "textDocument" },
                        onClick: actions.openPanel,
                    },
                    {
                        key: "correct",
                        text: t("orders.commandBar.correct") as string,
                        iconProps: { iconName: "SingleColumnEdit" },
                        onClick: actions.openPanelToCorrect,
                    }
                ];
                if(REACT_APP_OPTIMA_ENABLED === "1" && selectedOrder.optimaNumber == null){
                    arr.push(
                        {
                            key: "sync",
                            text: t("orders.commandBar.sync") as string,
                            onRenderIcon: () => {
                                return <img src={optimaIcon}  alt="optima" style={{maxHeight: '16px'}}/>;
                            },
                            onClick: async () => {
                               const response : any = await syncOptima (selectedOrder.id)
                               if(dispatch && typeof dispatch === 'function') {
                                   if (response.data.success === false) {
                                    dispatch(setListErr(t("orders.messages.syncError")))
                                   } else if (response.data.success === true) {
                                    dispatch(setListMessage(t("orders.messages.syncSuccess") as string))
                                    selectedOrder.optimaNumber = response.data.data
                                   }
                               }
                              },
                            });
                }
                if(REACT_APP_OPTIMA_ENABLED === "1" && selectedOrder.optimaNumber == null){
                    arr.push(
                        {
                            key: "seee",
                            text: t("orders.messages.manualSyncWithOptima") as string,
                            onRenderIcon: () => {
                                return <img src={optimaIcon}  alt="optima" style={{maxHeight: '16px'}}/>;
                            },
                            onClick: actions.openPanelSyncOrder,
                        })
                }
                if (selectedOrder && selectedOrder.cuoOrderMappingId != null && selectedOrder.cuoDeliveryReportSent === false) {
                    arr.push({
                        key: "retry-cuo-delivery-report",
                        text: t("orders.commandBar.syncWithCuo") as string,
                        iconProps: { iconName: "Sync" },
                        onClick: async () => {
                            const response: any = await retryCuoDeliveryReport(selectedOrder.id);
                            if (dispatch && typeof dispatch === 'function') {
                                if (response && response.data === true) {
                                    dispatch(setListMessage(t("orders.messages.cuoReportSent") as string));
                                    selectedOrder.cuoDeliveryReportSent = true;
                                } else {
                                    dispatch(setListErr(t("orders.messages.cuoReportError") as string));
                                }
                            }
                        }
                    });
                }


                return arr;
            }
            return [
                {
                    key: "see",
                    text: t("orders.commandBar.see") as string,
                    iconProps: { iconName: "textDocument" },
                    onClick: actions.openPanel,
                },
                {
                    key: "correct",
                    text: t("orders.commandBar.correct") as string,
                    iconProps: { iconName: "SingleColumnEdit" },
                    onClick: actions.openPanelToCorrect,
                }
            ];
        case Quantity.MANY:
            return [];
    }
};